<template>
    <v-container class="pt-5 marge">
        <v-row justify="center" offset-md="3">
            <v-col cols="12" md="1" class="align-self-center">
                <v-row justify="center" aling="center">
                    <v-btn class="mx-2"
                           fab
                           dark
                           large
                           color="warning">
                        <v-icon large>
                            mdi-eye-off
                        </v-icon>
                    </v-btn>
                </v-row>
            </v-col>
            <v-col cols="12" md="8">
                <h2 style="text-align: center" class="text-warning"><b>Datos incompletos o el reporte no es de su zona</b></h2>
                <div style="text-align:center">
                    <h4>
                        <b>
                            Comuníquese con el administrador del sistema para resolver el problema.
                        </b>
                    </h4>
                </div>
            </v-col>
            <!--<v-col cols="12" md="2">
            </v-col>-->
        </v-row>
    </v-container>
</template>
<script>
    export default {

    }
</script>
<style>
/*    .Table {
        display: table;
    }

    .Row {
        display: table-row;
    }

    .Cell {
        display: table-cell;
        padding-left: 5px;
        padding-right: 5px;
        align-content: center;
        vertical-align: middle;
    }*/
    @media (min-width:320px) {
        .marge {
            margin-top: 50%;
        }
    }

    @media (min-width:480px) {
        .marge {
            margin-top: 50%;
        }
    }

    @media (min-width: 576px) {
        .marge {
            margin-top: 30%;
        }
    }

    @media (min-width: 768px) {

        .marge {
            margin-top: 30%;
        }
    }

    @media (min-width: 900px) {
        .marge {
            margin-top: 25%;
        }
    }
</style>